module.exports = __webpack_public_path__ + "img/vnpay.2b3346e7.svg";